module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-6.ea360deb.mp3";